import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDarkMode } from '@base/store/theme/index';
import { toggleMobileMenu, mobileMenuSelector } from '@store/mobileMenu/index';
import { RootState } from '@base/store';

import { HeaderTopTypes } from './types';

const HeaderTopbar: React.FC<HeaderTopTypes> = ({ pageTitle, pageSubTitle }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const mobileMenu = useSelector(mobileMenuSelector);
    const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);
    const isProjectSubmission = location.pathname.startsWith('/project/');

    return (
        <div className="container-fluid py-6 py-lg-0 d-flex align-items-center justify-content-between">
            {/* Left side: Mobile menu button + Page title */}
            <div className="d-flex align-items-center flex-grow-1">
                {/* Mobile Menu Toggle Button */}
                <button 
                    onClick={() => dispatch(toggleMobileMenu())} 
                    className="btn btn-icon d-lg-none me-3"
                    aria-label="Toggle mobile menu"
                    style={{ 
                        minWidth: '44px', 
                        minHeight: '44px',
                        zIndex: 10,
                        pointerEvents: 'auto',
                        cursor: 'pointer',
                        position: 'relative',
                        backgroundColor: isDarkMode ? '#2d3748' : '#f8f9fa',
                        border: `1px solid ${isDarkMode ? '#4a5568' : '#dee2e6'}`,
                        borderRadius: '8px'
                    }}
                >
                    <i 
                        className={`fas ${mobileMenu.isOpen ? 'fa-times' : 'fa-bars'} fs-2`} 
                        style={{ 
                            color: isDarkMode ? '#e2e8f0' : '#495057'
                        }} 
                    />
                </button>
                
                <div className="page-title d-flex flex-column">
                    {pageTitle && (
                        <h1
                            className="d-flex flex-column text-dark fw-bolder fs-2 mb-0"
                            style={{ visibility: isProjectSubmission ? 'hidden' : 'visible' }}
                        >
                            {pageTitle}
                        </h1>
                    )}
                    {pageSubTitle && (
                        <>
                            <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                            <small className="text-muted fs-7 fw-bold my-1 ms-1">{pageSubTitle}</small>
                        </>
                    )}
                </div>
            </div>
            <div className="d-flex align-items-center">
                <button onClick={() => dispatch(toggleDarkMode())} className="dark-mode-toggle" aria-label="Toggle dark mode">
                    <i className="fas fa-sun" />
                    <i className="fas fa-moon" />
                </button>
            </div>
        </div>
    );
};

export default HeaderTopbar;
